import styled from 'styled-components';

interface TagContainerProps {
  color: string;
  variant: 'default' | 'outlined';
  compact: boolean;
}

const getPrimaryColor = (color: string) => {
  switch (color) {
    case 'green':
      return '#2CC84D';
    case 'blue':
      return '#17ABDD';
    case 'orange':
      return '#EA9900';
    default:
      return '#FD6262';
  }
};

export const TagContainer = styled.div<TagContainerProps>`
  display: flex;
  padding: ${({ compact }) => (compact ? '.1rem .5rem' : '.25rem .75rem')};
  border-radius: 1rem;
  width: fit-content;
  background: ${({ color, variant }) =>
    variant === 'outlined' ? 'transparent' : getPrimaryColor(color)};
  border: ${({ color, variant }) =>
    variant === 'outlined' ? `1px solid ${getPrimaryColor(color)}` : 'none'};

  span {
    font-family: 'Segoe UI', sans-serif;
    font-size: ${({ compact }) => compact ? '.6rem' : '.75rem'};
    line-height: 100%;
    font-weight: 700;
    color: ${({ color, variant }) =>
      variant === 'outlined' ? getPrimaryColor(color) : '#fff'};
  }
`;
